import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram, faTelegram, faLinkedin, faTwitter, faWhatsapp } from '@fortawesome/free-brands-svg-icons';

const Footer = () => {
    const [isChatButtonVisible, setIsChatButtonVisible] = useState(true);

    return (
        <>
            {isChatButtonVisible && (
                <div className="whatsapp-chat-widget">
                    <a
                        className="whatsapp-floating-chat"
                        href="https://wa.me/251913811743?text=Hello%2C%20I%20would%20like%20to%20ask%20a%20question."
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Chat with Ziyad Attorneys on WhatsApp"
                        title="Chat with us on WhatsApp"
                    >
                        <FontAwesomeIcon icon={faWhatsapp} aria-hidden="true" />
                        <span>Chat with us</span>
                    </a>
                    <button
                        className="whatsapp-chat-dismiss"
                        type="button"
                        onClick={() => setIsChatButtonVisible(false)}
                        aria-label="Close WhatsApp chat button"
                        title="Close"
                    >
                        <span aria-hidden="true">x</span>
                    </button>
                </div>
            )}

            <footer className="footer">
                <div className="footer-content">
                
                {/* Main Pages */}
                <div className="footer-section">
                    <h4>Main Pages</h4>
                    <ul>
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/about">About Us</Link></li>
                        <li><Link to="/services">Services</Link></li>
                        <li><Link to="/contact">Contact Us</Link></li>
                    </ul>
                </div>

                {/* Resources */}
                <div className="footer-section">
                    <h4>Resources</h4>
                    <ul>
                        <li><Link to="/resources">Legal Resources</Link></li>
                        <li><Link to="/blog">Blog</Link></li>
                    </ul>
                </div>

                {/* Contact Info */}
                <div className="footer-section">
                    <h4>Contact Information</h4>                    
                    <p>Addis Ababa, Ethiopia</p>
                    <div className="footer-phone-details">
                        <span className="footer-phone-label">Phone:</span>
                        <a className="footer-phone-primary" href="tel:+251913811743">+251-913-81-17-43</a>
                        <a className="footer-phone-secondary" href="tel:+251930750575">+251-930-75-05-75</a>
                    </div>
                    <p>Email: ziyadlawoffice@gmail.com</p>
                </div>

                {/* Social Links */}
                <div className="footer-section follow-us">
                    <h4>Follow Us</h4>
                    <div className="social-icons">
                        <a href="https://www.facebook.com/share/19bt5k7qjN/" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faFacebook} />
                        </a>
                        <a href="https://www.instagram.com/ziyad_attorneys?igsh=cWp5eGlycGhnZmU4" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faInstagram} />
                        </a>
                        <a href="https://t.me/Ziyad_Attorneys" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faTelegram} />
                        </a>
                        <a href="https://www.linkedin.com/in/ziyad-attorneys-99685237?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faLinkedin} />
                        </a>
                        <a href="https://x.com/ZydRed1?t=OkpnGn-EpubK0RBaz6eLUw&s=09" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faTwitter} />
                        </a>
                        <a href="https://wa.me/251913811743" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faWhatsapp} />
                        </a>
                    </div>
                </div>
                </div>

                {/* Bottom Note */}
                <div className="footer-bottom">
                    <p>&copy; 2025 Ziyad Attorneys</p>
                </div>
            </footer>
        </>
    );
};

export default Footer;

